
import { defineComponent } from 'vue';
import PrzItem from '../AbstractItem/Component.vue';
import PrzProfile from '../Parts/SocialProfile/Component.vue';
import PrzLikes from '../Parts/SocialLikes/Component.vue';
import { BlockItem } from '@/models/Blocks/Itens/block-item';
import { BlockSocial } from '@/models/Blocks/Itens/block-social';
//import { HistoryPosition } from '@/models/Blocks/history-position';

export default defineComponent({
    components:{
        PrzItem,
        PrzProfile,
        PrzLikes,
        PrzMention: () => import('./MentionModal.vue'),
    },
    props:{
        item:{
            type: BlockItem,
        }
    },
    data(){
        return {
            showModal: false
        }
    },
    created() {
        if(this.social?.url && this.social.url != '#'){
            this.social.url = this.getUrlWithOti(this.social.url);
        }
    },
    computed:{
        social(): BlockSocial|null{
            return this.item instanceof BlockSocial ? <BlockSocial>this.item : null;
        },
        likesInfo(): object|undefined{
            return this.social?.likes?.params() ?? undefined;
        },
        urlProfile(): string|undefined{
            if(this.social && this.social.urls.page){
                return this.getUrlWithOti(this.social.urls.page);
            }
            return undefined;
        },
        urlMention(): string|undefined{
            if(this.social && this.social.extraInfo && typeof this.social.extraInfo === 'string'){
                return this.getUrlWithOti(this.social.extraInfo);
            }
            return undefined;
        },
        mubDataProfile(): string|null{
            return !this.social ? null : JSON.stringify({
                t: 'socialprofile',
                b: this.social.blockName,
                m: !this.social.extraInfo || !this.social.extraInfo.profileId ? null : {
                    profileId: this.social.extraInfo.profileId,
                },
                obs: false,
            });
        }
    },
    methods:{
        like(){
            if(this.social && this.social.likes){
                this.social.likes.liked = !this.social.likes.liked;
                if(this.social.likes.liked){
                    this.social.likes.num++;
                }else{
                    this.social.likes.num--;
                }
            }
        },
        goto(){
            this.item && this.item.savePosition();
        },
        itemClick(){
            if(this.social && this.social.openModal && this.social.extraInfo){
                this.goto();
                this.showModal = true;
            }
        },
        getUrlWithOti(url: string): string|undefined{
            const b = this.social?.blockName;
            if(b){
                return url + (url.indexOf('?') > 0 ? '&' : '?') + 'oti=' + b;
            }
            return url;
        }
    }
});
